import { getLanguageKey, localizeItem } from '@/helpers/LocalizationHelper.js';

export const localizationMixin = {
  computed: {
    languageKey() {
      return getLanguageKey(this.$i18n.locale);
    }
  },

  methods: {
    localize(item) {
      return localizeItem(item, this.languageKey);
    }
  }
};
